import { mapActions, mapGetters } from 'vuex'

export const critereMixin = {
  data () {
    return {
      criteres: [],
      filterText: ''
    }
  },
  computed: {
    ...mapGetters([
      'getCriteresList',
      'getCritereToggle'
    ]),
    filterCriteres () {
      if (this.filterText != '') {
        this.emitOpenAllSousCritere()
      } else if (this.getCritereToggle === true) {
        this.emitOpenAllSousCritere()
      } else if (this.getCritereToggle === false) {
        this.emitCloseAllSousCritere()
      }

      // Recursive function
      // Keep the critere if it matches the filter text, or at least one of its children matches the filter text
      const matchesFilter = (critere, filterText) => {
        // Check if the current critere matches the filter text
        if (critere.chLibs.toLowerCase().includes(filterText.toLowerCase())) {
          return true;
        }
        // Keep Parent if at least one child matches
        if (critere.children) {
          const children = this.getCriteresList.filter(child => child.parent === critere.id);
          return children.some(child => matchesFilter(child, filterText));
        }
        return false;
      };

      return this.getCriteresList.filter(critere => {
        return matchesFilter(critere, this.filterText);
      });
    }
  },
  methods: {
    ...mapActions([
      'emitOpenAllSousCritere',
      'emitCloseAllSousCritere'
    ])
  }
}
